const topics = [
  { label: '91在线吃瓜', count: '2.3k', hot: true },
  { label: '最新入口', count: '1.8k', hot: true },
  { label: '线路一', count: '1.6k', hot: true },
  { label: '备用网址', count: '1.4k' },
  { label: '吃瓜通道', count: '1.2k', hot: true },
  { label: '官方线路', count: '987' },
  { label: '域名更新', count: '856' },
  { label: '访问教程', count: '743' },
  { label: '安全入口', count: '689' },
  { label: '移动端', count: '567' },
  { label: '在线吃瓜网', count: '521', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-8 rounded-lg bg-secondary-500/15 flex items-center justify-center flex-shrink-0">
            <i className="ri-hashtag text-secondary-400"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">热门话题</h2>
        </div>
        <div className="flex flex-wrap gap-2 md:gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-500/10 text-accent-400 border border-accent-500/20 hover:bg-accent-500/20'
                  : 'bg-background-100 text-foreground-400 border border-background-300/30 hover:border-foreground-500/30 hover:text-foreground-300'
              }`}
            >
              {topic.label}
              <span className="text-xs opacity-60">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}